import { atom } from "recoil";
import { getToken } from '../views/Login/loginUtils'

export const tokenState = atom({
  key: "token",
  default: getToken(),
});
